import { Observable, retry, timer } from 'rxjs';

export interface BackoffRetryConfig {
    count?: number;
    delay?: number;
    maxDelay?: number;
    logger?: (msg: unknown) => void;
}

/**
 * exponential backoff delay retry with configurable upper bound max delay
 * retryCount starts from 1.
 * Expected values: 1:0.25s 2:0.5s, 3:1s, 4:2s, 5:4s, 6:8s, 7:16s, 8:32s, 9:64s, 10:128s, 11:256s, 12:512s, ..., 100:5min
 **/
export function backoffRetry<T>({ count = 3, delay = 250, maxDelay = 600_000, logger }: BackoffRetryConfig) {
    return (obs$: Observable<T>) =>
        obs$.pipe(
            retry({
                count,
                delay: (_, retryCount) => {
                    const due = Math.min(maxDelay, Math.pow(2, retryCount - 1) * delay);
                    logger?.(`retry #${retryCount} after ${due / 1000}s`);
                    return timer(due);
                }
            })
        );
}
